/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//

export default {
  name: 'svg-icon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String
    }
  },
  computed: {
    iconName: function iconName() {
      return "#icon-".concat(this.iconClass);
    },
    svgClass: function svgClass() {
      if (this.className) {
        console.log('svg-icon ' + this.className);
        return 'svg-icon ' + this.className;
      } else {
        return 'svg-icon';
      }
    }
  }
};